module.exports = __webpack_public_path__ + "static/media/casino4.994aaa2d.jpg";